define( function() {
	"use strict";

	return ( /^$|\/(?:java|ecma)script/i );
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/manipulation/var/rscriptType.js
// module id = 1855
// module chunks = 37